export default __webpack_public_path__ + "static/media/restaumatic-light.b9b506cd.svg";